// unique scripts go here.

$.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

const hoist = JSON.parse(window.wpVars);

const instanceCarousels = () => {
    // $('.slides').slick({
    //     arrows: false,
    //     dots: false,
    //     speed: 1000,
    //     centerMode: true,
    //     slidesToShow: 3,
    //     centerMode: true,
    //     responsive: [
    //         {
    //             breakpoint: 1000,
    //             settings: {
    //                 slidesToShow: 1,
    //             }
    //         }
    //     ]
    // });

    if ( window.innerWidth < 1000 ) {

        $('.becomes-carousel-on-mobile').slick({
            arrows: false,
            dots: false,
            speed: 1000,
            slidesToShow: 1,
            adaptiveHeight: true,
            centerMode: true,
            centerPadding: '20%'
        })
    }
}


/**
 * @method formHandling
 * @see https://developer.mozilla.org/en-US/docs/Web/API/FormData/Using_FormData_Objects
 * @param evt Event handler
 *
 */

function formHandling(evt) {
    evt.preventDefault();
    var formData = $(this).serializeObject();
    var redirect = `${hoist.homeURL}/obrigado-pelo-seu-contato`;

    formData.url_atual = window.location.href;
    redirect = formData.redirect;

    var data = {
        action: 'mundi_submit_emails',
        values: formData
    };

    $.ajax({
        type: 'POST',
        url: hoist.adminURL,
        data: data,
        success: function (response) {
            window.setTimeout(function(){
            	window.location = redirect;
            }, 300);
        },
        fail: function () {
           alert('Houve um erro no envio do seu e-mail, por favor tente novamente mais tarde.');
        }
    });
}


const fixedHeader = () => {
    let y = window.pageYOffset;
    const masthead = document.querySelector('#masthead');

    y > 100 && window.innerWidth > 1000 ? masthead.classList.add('fixed') : masthead.classList.remove('fixed');
}